import { DashboardDateRangeDefaults } from './DashboardDateRangeFilterDropdown.types'

export const DashboardDateRangeDefaultsLabel = {
  [DashboardDateRangeDefaults.LAST_7_DAYS]: 'Last 7 Days',
  [DashboardDateRangeDefaults.LAST_30_DAYS]: 'Last 30 Days',
  [DashboardDateRangeDefaults.LAST_90_DAYS]: 'Last 90 Days',
  [DashboardDateRangeDefaults.LAST_YEAR]: 'Last Year',
}
